import { isDev } from 'pkg/flags';
import * as logger from 'pkg/logger';
import type { MiddlewareFn } from 'pkg/router/middlewares';
import type { RouteProps } from 'pkg/router/route';

const assumeLiteralObject = (
	value: unknown
): value is Record<string, unknown> =>
	value !== null && typeof value === 'object' && Array.isArray(value) === false;

export const invokeMiddlewares = (
	middlewares: MiddlewareFn[] | undefined,
	props: RouteProps,
	manipulateProps = true
): RouteProps => {
	if (!middlewares) return props;

	Array.from(middlewares).forEach((middleware) => {
		if (!manipulateProps) {
			middleware(props);
		} else {
			try {
				const result = middleware(props);

				if (assumeLiteralObject(result)) {
					props = { ...props, ...result };
				}
			} catch (error) {
				if (isDev()) {
					logger.error(
						new Error(
							`The above error occurred in middleware: ${middleware.name}`,
							{ cause: error }
						)
					);
				}
			}
		}
	});

	return props;
};
